import { useEffect, useRef, useState } from 'react'

import { KindVo } from '@eastcoal/api/content/interface'
import {
  queryKindListApi,
  QueryKindListParameter
} from '@eastcoal/api/content/priceIndexMall/queryKindList'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'
import { BasicProps } from '@eastcoal/common/types/component'
import { pick } from '@eastcoal/common/utils/object'

import { usePriceIndexChartStore } from '../../Store/hooks/useStore'

const getOptionValue = (value: KindVo) => {
  return `${value.id}`
}

const resolveOptions = (data: KindVo[]) => {
  return data.map(({ id, name }) => ({ value: id, label: name }))
}

export const PriceIndexChartKindSelect = (props: BasicProps) => {
  const { priceIndexType, dateRange, currentKind, setCurrentKind } =
    usePriceIndexChartStore(state =>
      pick(state, [
        'priceIndexType',
        'dateRange',
        'currentKind',
        'setCurrentKind'
      ])
    )

  const [data, setData] = useState<KindVo[]>([])
  const indexRef = useRef<number>(0)
  const timerRef = useRef<number>(undefined)

  const handleRequestSuccess = ({ list }: { list: KindVo[] }) => {
    setData(list)
  }

  const handleManualSelect = (value?: KindVo) => {
    clearTimeout(timerRef.current)
    setCurrentKind(value)
  }

  useEffect(() => {
    const loop = () => {
      setCurrentKind(data[indexRef.current])
      indexRef.current = (indexRef.current + 1) % data.length
      timerRef.current = window.setTimeout(loop, 10000)
    }
    loop()
    return () => {
      indexRef.current = 0
      clearTimeout(timerRef.current)
    }
  }, [data, setCurrentKind])

  useEffect(() => {
    if (dateRange) {
      clearTimeout(timerRef.current)
    }
  }, [dateRange])

  return (
    <RemoteSelect<KindVo, QueryKindListParameter, undefined>
      {...props}
      allowClear={false}
      api={queryKindListApi}
      getOptionValue={getOptionValue}
      readyRequest={priceIndexType !== undefined}
      refreshDeps={[priceIndexType]}
      resolveOptions={resolveOptions}
      value={currentKind}
      requestParams={{
        priceIndexType
      }}
      onChange={handleManualSelect}
      onRequestSuccess={handleRequestSuccess}
    />
  )
}
